import { render, staticRenderFns } from "./RaceTable.vue?vue&type=template&id=54c7a076&scoped=true&"
import script from "./RaceTable.vue?vue&type=script&lang=js&"
export * from "./RaceTable.vue?vue&type=script&lang=js&"
import style0 from "./RaceTable.vue?vue&type=style&index=0&id=54c7a076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c7a076",
  null
  
)

export default component.exports